import { createFileRoute } from "@tanstack/react-router";
import OpelHub from "@/pages/hub/OpelHub";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/hub/opel/")({
  head: () => routeHead("/de/hub/opel/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <OpelHub />
  );
}
